<script setup lang="ts">
	import type { DisclaimerRadioOptionContext } from '~/components/Ui/disclaimer-radio-option.vue'
	const selectedOptions = defineModel<string>()
	const options: DisclaimerRadioOptionContext = [
		{
			key: 'instant',
			title: {
				value: 'Instant Deactivation',
				className: 'text-error-500'
			},
			description: {
				value: 'This option will immediately remove the <span class ="text-primary-2 font-medium">selected staff</span> from all business plans. Deactivation takes effect right away, meaning they will no longer be tied to any plan, and the staff will no longer appear in the active list.',
				className: ''
			}
		},
		{
			key: 'pending',
			title: {
				value: 'Pending Deactivation',
				className: 'text-warning-500'
			},
			description: {
				value: 'With this option, the <span class="text-primary-2 font-medium">selected staff</span> will remain covered until the end of the first month in the renewal cycle. After this month, their access to their plans will automatically end, and they will be removed from the active staff list',
				className: ''
			}
		}
	]
	defineProps<{
		list?: DisclaimerRadioOptionContext | null
	}>()
</script>

<template>
	<div>
		<ui-disclaimer-radio-option v-model="selectedOptions" :list="list || options" />
	</div>
</template>
